import { Pipe, PipeTransform } from '@angular/core';
import { removeNonDigit } from '../utils/utils';
/*
 * Removes all non digit from string
 * Usage:
 *   value : value to transform
*/
@Pipe({ name: 'removeNonDigitPipe' })
export class RemoveNonDigitPipe implements PipeTransform {
  public transform(value: string): string {
    return removeNonDigit(value);
  }
}